<template>
	<div>
		<div class="row q-col-gutter-md q-pb-lg" v-if="!parameterSearch">
			<div class="col">
				<q-btn @click="createWatchlist" :label="$t('button.createWatchlist')" icon="create" color="primary" no-caps/>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<q-table :title="$t('watchlists')"
						 :data="watchlists"
						 :columns="columns"
						 :pagination.sync="pagination"
						 :loading="isLoading"
						 :filter="filter"
						 row-key="uid"
						 @request="onRequest"
				>
					<template v-slot:top-right>
						<q-input borderless dense debounce="300" v-model="filter" :placeholder="$t('label.search')">
							<template v-slot:append>
								<q-icon name="search"/>
							</template>
						</q-input>
					</template>
					<template v-slot:body-cell-name="cell">
						<q-td>
							<template v-if="!emit">
								<watchlist-link :watchlist="cell.row"/>
							</template>
							<template v-else>
								<watchlist-teaser :watchlist="cell.row" @click.native="$emit('select-watchlist', cell.row)"/>
							</template>
						</q-td>
					</template>
					<template v-slot:body-cell-actions="cell">
						<q-btn color="primary" icon="more_vert" outline dense v-if="!parameterSearch">
							<q-menu>
								<q-list>
									<q-item @click="editWatchlist(cell.row)" clickable v-close-popup>
										<q-item-section>{{ $t('button.watchlistSettings') }}</q-item-section>
									</q-item>
									<q-item @click="share(cell.row)" clickable v-close-popup>
										<q-item-section>{{ $t('button.share') }}</q-item-section>
									</q-item>
									<q-item @click="downloadWatchlistSummary(cell.row)" v-if="!cell.row.searchParams" clickable v-close-popup>
										<q-item-section>{{ $t('button.downloadWatchlistSummary') }}</q-item-section>
									</q-item>
									<q-item @click="deleteWatchlist(cell.row)" clickable v-close-popup>
										<q-item-section>{{ $t('button.deleteWatchlist') }}</q-item-section>
									</q-item>
								</q-list>
							</q-menu>
						</q-btn>
					</template>
				</q-table>
			</div>
		</div>
	</div>
</template>

<script>
	import {FETCH_WATCHLISTS} from "@/store/actions.type";
	import WatchlistLink from "@/components/watchlist/WatchlistLink";
	import {mapGetters} from "vuex";
	import WatchlistTeaser from "@/components/watchlist/WatchlistTeaser";
	import {area} from "@/mixins/NumberFormattingFilters";
	import moment from "moment";
	import WatchlistActions from "@/mixins/WatchlistActions";
	import {SET_WATCHLISTS_FILTER, SET_WATCHLISTS_PAGINATION, SHOW_DIALOG} from "@/store/mutations.type";
	import {INITIAL_WATCHLISTS_PAGINATION} from "@/common/constants";

	export default {
		name: "Watchlists",
		mixins: [WatchlistActions],
		components: {WatchlistTeaser, WatchlistLink},
		props: {
			emit: Boolean,
			parameterSearch: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isLoading: false,
				columns: [
					{
						name: 'name',
						required: true,
						label: this.$t('label.watchlistName'),
						align: 'left',
						sortable: true
					},
					{name: 'customerName', align: 'center', label: this.$t('customer'), field: 'customerName', sortable: true},
					{name: 'crdate', label: this.$t('label.crdate'), field: 'crdate', sortable: true, format: (val, row) => moment(val).format(this.$t('dateFormat.short'))},
					{name: 'seller', label: this.$t('label.seller'), field: 'seller', format: (val, row) => val ? val.fullName : '', sortable: true},
					{name: 'type', label: this.$t('label.type'), field: 'dynamic', format: (val, row) => val ? this.$t('dynamic') : this.$t('static')},
					{name: 'language', label: this.$t('label.language'), field: 'zohoLanguage'},
					{name: 'currency', label: this.$t('currency'), field: 'currency'},
					{name: 'itemCount', label: this.$t('label.itemCount'), field: 'items', format: (val, row) => row.searchParams.length ? this.$t('emptyTableColumn') : val.length},
					{name: 'totalArea', label: this.$t('resultArea'), field: 'totalArea', sortable: true, format: (val, row) => val ? area(val) : this.$t('emptyTableColumn')},
					{name: 'shared', label: this.$t('shared'), field: 'shared', format: (val, row) => {return val && row.sharedUntil*1000 > moment() ? this.$t('yes') : this.$t('no')}},
					{name: 'actions', align: 'right'}
				],
			}
		},
		computed: {
			...mapGetters(['watchlists', 'watchlistsPagination']),
			filter: {
				get() {
					return this.$store.state.watchlist.watchlistsFilter;
				},
				set(value) {
					this.$store.commit(SET_WATCHLISTS_FILTER, value);
				}
			},
			pagination: {
				get() {
					return this.watchlistsPagination;
				},
				set(newValue) {
					this.$store.commit(SET_WATCHLISTS_PAGINATION, newValue);
				}
			}
		},
		async mounted() {
			if(!this.watchlists.length) {
				this.onRequest({
					pagination: this.pagination,
					filter: this.filter
				});
			} else {
				this.pagination = this.watchlistsPagination;
			}
		},
		methods: {
			async onRequest(props) {
				this.isLoading = true;
				await this.$store.dispatch(FETCH_WATCHLISTS, {...props, parameterSearch: this.parameterSearch});

				this.pagination = this.watchlistsPagination;

				this.isLoading = false;
			},
			createWatchlist: function () {
				this[SHOW_DIALOG]({
					component: 'WatchlistSettings',
					title: 'button.createWatchlist',
					persistent: true,
					closeButton: false,
					watchlist: {}
				});
			}
		}
	}
</script>